<div class="page-title animatedBackground">
    <div class="container">
        <h3>Request Quotation</h3>
        <ul>
            <li><a routerLink="/">Home</a></li>
            <li class="dot-divider"></li>
            <li>Request Quotation</li>
        </ul>
    </div>
    <div class="bg-pattern"><img src="assets/img/bg-pattern-2.png" alt="pattern"></div>
</div>
<section class="analysis-area ptb-100 bg-fbf9f8">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-5 col-md-12">
                <div class="analysis-form">
                    <h3>Request For Quotation
                    </h3>
                    <form>
                        <div class="form-group">
                            <input type="text" [(ngModel)]="name" [ngModelOptions]="{standalone: true}" placeholder="Name*" class="form-control">
                        </div>
                        <div class="form-group">
                            <input type="email" [(ngModel)]="email" [ngModelOptions]="{standalone: true}" placeholder="Email*" class="form-control">
                        </div>
                        <div class="form-group">
                            <input type="text" [(ngModel)]="phone" [ngModelOptions]="{standalone: true}" placeholder="Phone*" class="form-control">
                        </div>
                        <div class="form-group">
                            <input type="text" [(ngModel)]="website" [ngModelOptions]="{standalone: true}" placeholder="Website" class="form-control">
                        </div>
                        <div class="form-group">
                            <input type="text" [(ngModel)]="company" [ngModelOptions]="{standalone: true}" placeholder="Company Name*" class="form-control">
                        </div>
                        <div class="form-group">
                           <select [(ngModel)]="service" [ngModelOptions]="{standalone: true}" name="services" class="form-control">
                            <option value="">-- Select Service* --</option>
                            <option>Odoo Customization & Support</option>
                            <option>Web Application Development</option>
                            <option>Mobile Application Developemnt</option>
                            <option>Ecommerce Developemnt</option>
                            <option>Custom Development</option>
                            <option>Cloud Services</option>
                            <option>Cyber Security Services</option>
                            <option>Openbravo</option>
                            <option>HR Management System</option>
                            <option>Point of Sale (POS)</option>
                            <option>Hospital Management System</option>
                            <option>Logistics Management System</option>
                            <option>Other</option>
                            </select>
                        </div>
                        <div class="form-group">
                          <textarea [(ngModel)]="message" [ngModelOptions]="{standalone: true}" class="form-control" rows="5" placeholder="Message*"></textarea>
                        </div>

                        <button type="button" (click)="onSubmit()" class="btn btn-primary">Request Now</button>
                    </form>
                </div>
            </div>
            
            <div class="col-lg-7 col-md-12">
                <div class="analysis-text">
                  <!--  <span>Free SEO Analysis</span> -->
                    <h3>Your Trusted Partner on The Digital Journey</h3>
                    <p>In a world that is anything but changing, we step in to help business steer their course to the top. Putting together the right mix of human ingenuity and technical capabilities, we help narrate your success story and turn it into a reality.</p>
                    <ul >
                        <li><span style="font-size: 20px;"><b>O</b></span>ptimum</li>
                        <li><span style="font-size: 20px;"><b>S</b></span>implicity</li>
                        <li><span style="font-size: 20px;"><b>I</b></span>ntegrity</li>
                        <li><span style="font-size: 20px;"><b>T</b></span>rust and Respect</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</section>